import ApiClient from './ApiClient';

export const buildCampaignParams = (page, sortAttr, search, limit, combo_select) => {
  let params = `type=whatsapp&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (limit) {
    params = `${params}&limit=${limit}`;
  }
  if (combo_select) {
    params = `${params}&combo_select=true`;
  }

  return params;
};

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getWhatsapp(page, sortAttr = 'title', limit, combo_select) {
    let requestURL = `${this.url}?${buildCampaignParams(
      page,
      sortAttr,
      '',
      limit,
      combo_select
    )}`;
    return axios.get(requestURL);
  }

  search(page = 1, sortAttr = 'title', search = '') {
    let requestURL = `${this.url}/search?${buildCampaignParams(
      page,
      sortAttr,
      search
    )}`;
    return axios.get(requestURL);
  }

  createFormData(campaignObj) {
    const formData = new FormData();
    const fields = Object.keys(campaignObj);
    fields.forEach((field) => {
      switch (field) {
        case 'trigger_rules':
          formData.append(field, JSON.stringify(campaignObj[field]));
          break;
        default:
          if (campaignObj[field]) {
            formData.append(field, campaignObj[field]);
          }
          break;
      }
    });
    return axios.post(this.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  analyzeFile(file, countryDDI) {
    const formData = new FormData();
    formData.append('campaign[file]', file);
    formData.append('campaign[country_DDI]', countryDDI);
    return axios.post(`${this.url}/analyze_file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new CampaignsAPI();
